import { $, Iterator } from '@starberry/components';

const PendingActions = {
  $: 'Stack',

  template: {
    $: 'Stack',
    props: {
      direction: 'column',
      spacing: 7,
    },
    children: [
      {
        $: 'ActionableListItem',
        data: (_, context) => context.data,
        time: $('value'),
        actions: [
          {
            label: 'Cancel',
            onClick: () => {
              alert('Done');
            },
          },
        ],
        props: {
          mb: 3,
        },
      },
    ],
  },

  children: (props) => [
    !props.hideTitle && { $: 'SectionHeading', title: 'Pending Actions', props: { mb: 7 } },
    {
      component: Iterator,
      provide: ['action'],
      props: {
        template: props.template,
        data: 'state.action.0.pendingActionData',
        limit: props.limit || 5,
      },
    },
  ],
};

export default PendingActions;
